import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IContact from "../models/IContact";
import IOnGetContactsDTO from "../models/DTO/IOnGetContactsDTO";

const getContacts = async (name: string, userModel: IUserUI, supplierModel: ISupplierModel, vendorId?: number): Promise<IContact[]> => {
    const query: Record<string, any> = { name };

    if (vendorId) {
        query.vendor_id = vendorId;
    }

    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.ContactsGetAll,
        query,
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, { method: "GET", headers });

    if (!response.ok) {
        throw new Error(`Failed to fetch contacts: ${response.statusText}`);
    }

    const data = (await response.json()) as IOnGetContactsDTO;
    return data.contacts;
};

const ContactsService = {
    getContacts,
};

export default ContactsService;
